<ax-icon class="icon" [name]="property?.value | categoryIcon"></ax-icon>
<ax-default-value-view
  [property]="property"
  [showVerificationLabel]="showVerificationLabel"
  [clickable]="false"
></ax-default-value-view>
